import { render, staticRenderFns } from "./ruta-foodies.vue?vue&type=template&id=2b396696&"
import script from "./ruta-foodies.vue?vue&type=script&lang=js&"
export * from "./ruta-foodies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports